import {StepPayload} from '@blesk-frontend/api';
import {
  ArrowDown,
  ArrowUp,
  CopyPlus,
  Eye,
  EyeOff,
  ImageOff,
  ImageUp,
  ImageUpscale,
  Trash,
} from 'lucide-react';
import {toast} from 'sonner';
import {Menu, MenuGroup, MenuItem, MenuItemConfirm, MenuItemUpload} from '../../components';

interface StepMenuProps {
  step: StepPayload;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onToggleHideStep: () => void;
  onDuplicateStep: () => void;
  onDeleteStep: () => void;
  onEditScreenshot: () => void;
  onUploadScreenshot: (src: string) => void;
  onDeleteScreenshot: () => void;
}

export const StepMenu = ({
  step,
  onMoveUp,
  onMoveDown,
  onToggleHideStep,
  onDuplicateStep,
  onDeleteStep,
  onEditScreenshot,
  onUploadScreenshot,
  onDeleteScreenshot,
}: StepMenuProps) => {
  const onUploaded = (url: string) => {
    onUploadScreenshot(url);
  };

  const onUploadError = (error: Error) => {
    // @ts-expect-error
    if (error.response.data.message.includes('expected size is less than')) {
      toast.error('Слишком большой файл', {
        description: 'Максимальный размер файла 5 МБ',
      });
    } else {
      toast.error('При загрузке скриншота произошла ошибка');
    }
  };

  return (
    <Menu>
      <MenuGroup>
        <MenuItem icon={ArrowUp} onClick={onMoveUp}>
          Переместить выше
        </MenuItem>
        <MenuItem icon={ArrowDown} onClick={onMoveDown}>
          Переместить ниже
        </MenuItem>
      </MenuGroup>
      <MenuGroup>
        <MenuItem
          icon={step.meta.hidden ? Eye : EyeOff}
          autoClose={false}
          onClick={onToggleHideStep}
        >
          {step.meta.hidden ? 'Показать шаг' : 'Скрыть шаг'}
        </MenuItem>
        <MenuItem icon={CopyPlus} onClick={onDuplicateStep}>
          Дублировать шаг
        </MenuItem>
      </MenuGroup>
      <MenuGroup>
        <MenuItem icon={ImageUpscale} disabled={!step.src.original} onClick={onEditScreenshot}>
          Редактировать скриншот
        </MenuItem>
        <MenuItemUpload
          icon={ImageUp}
          autoClose={false}
          accept={{
            'image/*': ['.webp', '.png', '.gif', '.jpg', '.jpeg'],
          }}
          onUploaded={onUploaded}
          onUploadError={onUploadError}
        >
          Загрузить скриншот
        </MenuItemUpload>
        <MenuItemConfirm
          variant="danger"
          icon={ImageOff}
          message="Нажмите еще раз"
          disabled={!step.src.original}
          onClick={onDeleteScreenshot}
        >
          Удалить скриншот
        </MenuItemConfirm>
      </MenuGroup>
      <MenuGroup>
        <MenuItemConfirm
          variant="danger"
          icon={Trash}
          message="Нажмите еще раз"
          onClick={onDeleteStep}
        >
          Удалить шаг
        </MenuItemConfirm>
      </MenuGroup>
    </Menu>
  );
};
